import { z } from "zod";
import type { CharacterDraft, CharacterExport } from "./types";

const exportSchema = z.object({
  version: z.literal(2),
  catalogVersion: z.string().min(1),
  character: z
    .object({
      level: z.number().int().min(1).max(21),
      name: z.string().max(120),
      gender: z.enum(["", "Male", "Female", "Other"]),
      backstory: z.string().max(4000),
      origin: z.string().nullable(),
      special: z.record(z.string(), z.number()),
      skills: z.record(
        z.string(),
        z.object({
          base: z.number(),
          invested: z.number(),
          is_main: z.boolean(),
        }),
      ),
      perks: z.record(z.string(), z.number()),
    })
    .passthrough(),
});

export function createExport(
  character: CharacterDraft,
  catalogVersion: string,
): CharacterExport {
  return { version: 2, catalogVersion, character: structuredClone(character) };
}

export function parseImport(value: unknown): CharacterExport {
  const parsed = exportSchema.safeParse(value);
  if (!parsed.success)
    throw new Error(
      "Файл персонажа имеет неверный или неподдерживаемый формат.",
    );
  return parsed.data as CharacterExport;
}
